export const getHeaders = (): string[] => [
  'Period',
  'Company',
  'Agreement date',
  '# of shares',
  'Investment',
  'Fair value',
  'Gain / loss',
  'Holding',
  'MOIC',
  'IRR',
  'Company valuation',
  'Country',
  'Industry',
  'Active/Realized',
];
